import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '소개', to: '/home' },
  { label: '문의', to: '/QnA' },
  { label: '광고', to: '/ad' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <div>
      {/* 로고 + 햄버거 */}
      <div className="px-6 py-4 md:py-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between md:justify-center">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <div className="font-headline font-black text-3xl md:text-5xl" style={{ color: '#1A1A1A' }}>
              CARATINGS
            </div>
          </Link>
          <button
            className="md:hidden flex flex-col justify-center gap-[5px] p-2"
            onClick={() => setOpen(o => !o)}
            aria-label="메뉴"
          >
            <span className="block w-6 h-0.5 bg-[#1A1A1A]" />
            <span className="block w-6 h-0.5 bg-[#1A1A1A]" />
            <span className="block w-6 h-0.5 bg-[#1A1A1A]" />
          </button>
        </div>
      </div>

      {/* 날짜 스트립 */}
      <div style={{ borderBottom: '1px solid #E5E5E5' }}>
        <div className="max-w-7xl mx-auto px-6 py-1.5 flex items-center justify-between">
          <span className="text-xs" style={{ fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 700, color: '#6B7280' }}>
            {(() => {
              const d = new Date();
              const year    = d.getFullYear();
              const month   = String(d.getMonth() + 1).padStart(2, '0');
              const day     = String(d.getDate()).padStart(2, '0');
              return `${year}년 ${month}월 ${day}일`;
            })()}
          </span>
          <span className="hidden md:inline" style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: '#AAA', letterSpacing: '0.12em' }}>
            TODAY'S UPDATE
          </span>
        </div>
      </div>

      {/* 데스크탑 네비 */}
      <div className="hidden md:block">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center justify-center">
            {navLinks.map(l => (
              <Link key={l.to} to={l.to}
                className="font-sans text-sm font-semibold px-6 py-3"
                style={{ textDecoration: 'none', color: '#1A1A1A', borderBottom: pathname === l.to ? '2px solid #1A1A1A' : '2px solid transparent' }}>
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      {open && (
        <div className="md:hidden border-t border-[#E5E5E5]">
          {navLinks.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block font-sans text-sm font-semibold px-6 py-4 border-b border-[#F0F0F0]"
              style={{
                textDecoration: 'none',
                color: '#1A1A1A',
                borderLeft: pathname === l.to ? '3px solid #1A1A1A' : '3px solid transparent',
              }}>
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
